import type { Integration } from '../../../types/api';
import { FormField, FormLabel, FormInput } from '../../ui';

interface GeneralTabProps {
  integration: Integration | null;
}

function GeneralTab({ integration }: GeneralTabProps) {
  return (
    <div className="space-y-6">
      <FormField>
        <FormLabel htmlFor="description" required>
          Descrição
        </FormLabel>
        <FormInput
          id="description"
          name="description"
          defaultValue={integration?.description}
          required
        />
      </FormField>
    </div>
  );
}

export default GeneralTab;
